import { getQaSelector } from '../../../../utils/common'
import {
  APPLICANT_BOARD_COLUMN_ORDER,
  QA_NAME_APPLICANT_BOARD,
} from '../RentalPortalApplicants.constants'

import { RentalPortalApplicantsBoardColumn } from './RentalPortalApplicantsBoardColumn'

import * as styles from './RentalPortalApplicantsBoard.module.css'

function RentalPortalApplicantsBoard({
  ErrorState,
  columns,
  hasError,
  isLoading,
  onClickCard,
  onMouseDownCard,
  onRetry,
  onShowMore,
}) {
  return hasError ? (
    <ErrorState isRefetching={isLoading} onRetry={onRetry} />
  ) : (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_BOARD })}
      className={styles.RentalPortalApplicantsBoard}
    >
      {APPLICANT_BOARD_COLUMN_ORDER.map(stage => (
        <RentalPortalApplicantsBoardColumn
          column={columns[stage]}
          isLoading={isLoading}
          key={stage}
          stage={stage}
          onClickCard={onClickCard}
          onMouseDownCard={onMouseDownCard}
          onShowMore={onShowMore}
        />
      ))}
    </div>
  )
}

export default RentalPortalApplicantsBoard
